// UI phrase dictionary - English text as it appears on screen -> translation.
//
// This is what makes the language choice reach the WHOLE software without
// touching every screen: LanguageContext walks the page and swaps any text
// that matches a phrase here (menus, tabs, buttons, labels, placeholders,
// tooltips). A phrase that is not here stays in English, so a partly
// translated language is always usable. Data (names, numbers, amounts) is
// never in this list, so it is never touched.
//
// Keys are EXACT screen text (case and punctuation). Add a phrase here and it
// is translated everywhere it appears.

const hi = {
  // ---- login ----
  'Welcome back': 'वापसी पर स्वागत है',
  'Sign in to your Hotel Desk account': 'अपने Hotel Desk खाते में साइन इन करें',
  'Company Code': 'कंपनी कोड',
  'Enter company code': 'कंपनी कोड दर्ज करें',
  'Provided by your administrator': 'आपके एडमिनिस्ट्रेटर द्वारा दिया गया',
  'Username': 'यूज़रनेम',
  'Enter username': 'यूज़रनेम दर्ज करें',
  'Password': 'पासवर्ड',
  'Enter password': 'पासवर्ड दर्ज करें',
  'Remember me': 'मुझे याद रखें',
  'Forgot password?': 'पासवर्ड भूल गए?',
  'Sign In': 'साइन इन',
  'Signing in...': 'साइन इन हो रहा है...',
  'Need help?': 'मदद चाहिए?',
  'Contact your administrator': 'अपने एडमिनिस्ट्रेटर से संपर्क करें',
  "Don't have an account?": 'खाता नहीं है?',
  'Sign Up': 'साइन अप',
  'HOTEL MANAGEMENT SYSTEM': 'होटल मैनेजमेंट सिस्टम',
  'Hotel Operations': 'होटल संचालन',
  'Restaurant Operations': 'रेस्टोरेंट संचालन',
  'Made': 'बना',
  'Simple.': 'आसान।',
  'Room Management': 'रूम मैनेजमेंट',
  'Track availability & housekeeping': 'उपलब्धता और हाउसकीपिंग पर नज़र',
  'Reservations': 'रिज़र्वेशन',
  'Manage bookings and guest stays': 'बुकिंग और गेस्ट स्टे प्रबंधित करें',
  'Integrated with Dine Master': 'Dine Master के साथ जुड़ा',
  'Payments & Billing': 'पेमेंट और बिलिंग',
  'Invoice, ledger and settlements': 'इनवॉइस, लेजर और सेटलमेंट',
  'Real-time business insights': 'रीयल-टाइम बिज़नेस जानकारी',
  'Multi-Property': 'मल्टी-प्रॉपर्टी',
  'Manage multiple hotels': 'कई होटल प्रबंधित करें',
  'Manage reservations, rooms, restaurant, guest services, payments and more — all in one place.': 'रिज़र्वेशन, रूम, रेस्टोरेंट, गेस्ट सर्विस, पेमेंट और बहुत कुछ — सब एक जगह।',
  'Language': 'भाषा',

  // ---- shell ----
  'Dashboard': 'डैशबोर्ड',
  'Hotel Dashboard': 'होटल डैशबोर्ड',
  'Restaurant Dashboard': 'रेस्टोरेंट डैशबोर्ड',
  'Ask AI': 'AI से पूछें',
  'Reception': 'रिसेप्शन',
  'Bookings': 'बुकिंग',
  'Guests': 'गेस्ट',
  'Group Booking': 'ग्रुप बुकिंग',
  'Channel Manager': 'चैनल मैनेजर',
  'Rates & Inventory': 'रेट और इन्वेंटरी',
  'Reset Data': 'डेटा रीसेट',
  'Accommodation': 'आवास',
  'Dormitories': 'डॉरमेट्री',
  'Bed Map': 'बेड मैप',
  'Banquet Hall': 'बैंक्वेट हॉल',
  'Banquet Package': 'बैंक्वेट पैकेज',
  'Restaurant': 'रेस्टोरेंट',
  'Orders': 'ऑर्डर',
  'Kitchen': 'किचन',
  'KOT Report': 'KOT रिपोर्ट',
  'Pub / Club': 'पब / क्लब',
  'Card Requests': 'कार्ड रिक्वेस्ट',
  'Services': 'सर्विस',
  'Spa Bookings': 'स्पा बुकिंग',
  'Spa Services': 'स्पा सर्विस',
  'Spa Therapists': 'स्पा थेरेपिस्ट',
  'Laundry Orders': 'लॉन्ड्री ऑर्डर',
  'Laundry Items': 'लॉन्ड्री आइटम',
  'Mini-Bar Consumption': 'मिनी-बार खपत',
  'Mini-Bar Items': 'मिनी-बार आइटम',
  'Housekeeping Dashboard': 'हाउसकीपिंग डैशबोर्ड',
  'Housekeeping Tasks': 'हाउसकीपिंग टास्क',
  'Housekeeping Staff': 'हाउसकीपिंग स्टाफ',
  'Store': 'स्टोर',
  'Store Items': 'स्टोर आइटम',
  'Stores (Main / Sub)': 'स्टोर (मुख्य / उप)',
  'Stores (Main/Sub)': 'स्टोर (मुख्य/उप)',
  'Stock': 'स्टॉक',
  'Stock Transfer': 'स्टॉक ट्रांसफर',
  'Stock History': 'स्टॉक हिस्ट्री',
  'Opening / Closing': 'ओपनिंग / क्लोज़िंग',
  'Kitchen Indent': 'किचन इंडेंट',
  'Indent Orders List': 'इंडेंट ऑर्डर सूची',
  'Purchase': 'खरीद',
  'Purchase Entry': 'खरीद एंट्री',
  'Suppliers': 'सप्लायर',
  'Recipes': 'रेसिपी',
  'Expiry Report': 'एक्सपायरी रिपोर्ट',
  'Accounts': 'अकाउंट्स',
  'Payments': 'पेमेंट',
  'Petty Cash': 'पेटी कैश',
  'Customer Wallet': 'कस्टमर वॉलेट',
  'Customer Due Report': 'कस्टमर बकाया रिपोर्ट',
  'Corrections': 'सुधार',
  'Staff': 'स्टाफ',
  'HR Dashboard': 'HR डैशबोर्ड',
  'HR Reports': 'HR रिपोर्ट',
  'Departments': 'विभाग',
  'Designations': 'पदनाम',
  'Employees': 'कर्मचारी',
  'Shifts': 'शिफ्ट',
  'Attendance': 'उपस्थिति',
  'Leave Types': 'छुट्टी के प्रकार',
  'Leave Requests': 'छुट्टी के आवेदन',
  'Overtime': 'ओवरटाइम',
  'Advance Salary': 'एडवांस सैलरी',
  'Loans': 'लोन',
  'Salary Structure': 'सैलरी स्ट्रक्चर',
  'Payroll': 'पेरोल',
  'Salary Payments': 'सैलरी भुगतान',
  'Service Charge': 'सर्विस चार्ज',
  'Tips': 'टिप्स',
  'Staff Meals': 'स्टाफ भोजन',
  'Uniform Deposit': 'यूनिफ़ॉर्म डिपॉज़िट',
  'Reports': 'रिपोर्ट',
  'Booking Report': 'बुकिंग रिपोर्ट',
  'Booking Ledger': 'बुकिंग लेजर',
  'Guest Report': 'गेस्ट रिपोर्ट',
  'Night Audit': 'नाइट ऑडिट',
  'Occupancy Report': 'ऑक्यूपेंसी रिपोर्ट',
  'Banquet Report': 'बैंक्वेट रिपोर्ट',
  'Banquet Calendar': 'बैंक्वेट कैलेंडर',
  'Settlement Report': 'सेटलमेंट रिपोर्ट',
  'Sale Report (Per Day)': 'सेल रिपोर्ट (प्रति दिन)',
  'Security Deposits': 'सिक्योरिटी डिपॉज़िट',
  'Hold / Maintenance Rooms': 'होल्ड / मेंटेनेंस रूम',
  'Package Report': 'पैकेज रिपोर्ट',
  'Add-On Amount': 'ऐड-ऑन राशि',
  'Room List': 'रूम सूची',
  'Invoice Report': 'इनवॉइस रिपोर्ट',
  'Item Report': 'आइटम रिपोर्ट',
  'Restro Report': 'रेस्ट्रो रिपोर्ट',
  'Booking History': 'बुकिंग हिस्ट्री',
  'All Category Report': 'सभी कैटेगरी रिपोर्ट',
  'Purchase Reports': 'खरीद रिपोर्ट',
  'Purchase Ledger': 'खरीद लेजर',
  'Agent Report': 'एजेंट रिपोर्ट',
  'Agent Commission': 'एजेंट कमीशन',
  'Agent Commission (Old)': 'एजेंट कमीशन (पुराना)',
  'Activity Log': 'एक्टिविटी लॉग',
  'GST Reports': 'GST रिपोर्ट',
  'Subscription Payments': 'सब्सक्रिप्शन भुगतान',
  'Marketing': 'मार्केटिंग',
  'Marketing Dashboard': 'मार्केटिंग डैशबोर्ड',
  'Customers': 'कस्टमर',
  'Campaigns': 'कैंपेन',
  'Automations': 'ऑटोमेशन',
  'Loyalty Points': 'लॉयल्टी पॉइंट',
  'Marketing Settings': 'मार्केटिंग सेटिंग',
  'Setup': 'सेटअप',
  'My Hotel': 'मेरा होटल',
  'Rooms': 'रूम',
  'Room Types': 'रूम टाइप',
  'Packages': 'पैकेज',
  'Extras': 'एक्स्ट्रा',
  'Restaurant Setup': 'रेस्टोरेंट सेटअप',
  'QR Codes': 'QR कोड',
  'Online Ordering': 'ऑनलाइन ऑर्डरिंग',
  'Tally & SAP': 'Tally और SAP',
  'Agents': 'एजेंट',
  'Coupons': 'कूपन',
  'Company Settings': 'कंपनी सेटिंग',
  'Business Settings': 'बिज़नेस सेटिंग',
  'Front Website': 'फ्रंट वेबसाइट',
  'Users': 'यूज़र',
  'Add User': 'यूज़र जोड़ें',
  'User Access': 'यूज़र एक्सेस',
  'Roles': 'रोल',
  'User Report': 'यूज़र रिपोर्ट',
  'Companies': 'कंपनियाँ',
  'Menus': 'मेनू',
  'Help Console': 'हेल्प कंसोल',
  'Help': 'मदद',
  'Logout': 'लॉगआउट',
  'Are you sure you want to logout?': 'क्या आप लॉगआउट करना चाहते हैं?',
  'Hotel Staff': 'होटल स्टाफ',
  'Restaurant Staff': 'रेस्टोरेंट स्टाफ',
  'Search guest, booking, room...': 'गेस्ट, बुकिंग, रूम खोजें...',
  'LIVE': 'लाइव',
  'Hotel': 'होटल',
  'Hotel Management': 'होटल मैनेजमेंट',

  // ---- workspace tabs ----
  'Overview': 'ओवरव्यू',
  'New Booking': 'नई बुकिंग',
  'Quick Booking': 'क्विक बुकिंग',
  'Hourly': 'घंटे के हिसाब',
  'Fast Booking': 'फास्ट बुकिंग',
  'Room Reservation': 'रूम रिज़र्वेशन',
  'Hourly Booking': 'घंटे की बुकिंग',
  'Block Room': 'रूम ब्लॉक',
  'Banquet Bookings': 'बैंक्वेट बुकिंग',
  'Today': 'आज',
  'Room Calendar': 'रूम कैलेंडर',
  'New Order': 'नया ऑर्डर',
  'Quick Bill': 'क्विक बिल',
  'Table Orders': 'टेबल ऑर्डर',
  'Room Orders': 'रूम ऑर्डर',
  'KOT': 'KOT',
  'Bills': 'बिल',
  'Inventory & Purchase': 'इन्वेंटरी और खरीद',
  'Housekeeping': 'हाउसकीपिंग',
  'Tasks': 'टास्क',
  'Guest Services': 'गेस्ट सर्विस',
  'Therapists': 'थेरेपिस्ट',
  'Laundry': 'लॉन्ड्री',
  'Mini Bar': 'मिनी बार',
  'Mini Bar Items': 'मिनी बार आइटम',
  'HR & Payroll': 'HR और पेरोल',
  'Leave': 'छुट्टी',
  'Salary': 'सैलरी',
  'Loans & Advances': 'लोन और एडवांस',
  'Finance': 'फाइनेंस',
  'Guest Wallet': 'गेस्ट वॉलेट',
  'GST': 'GST',
  'Subscription': 'सब्सक्रिप्शन',
  'Booking': 'बुकिंग',
  'Invoice': 'इनवॉइस',
  'Guest': 'गेस्ट',
  'Package': 'पैकेज',
  'Add-On': 'ऐड-ऑन',
  'Add-Ons': 'ऐड-ऑन',
  'Agent': 'एजेंट',
  'Commission': 'कमीशन',
  'Hold / Maint.': 'होल्ड / मेंटेनेंस',
  'Audit History': 'ऑडिट हिस्ट्री',
  'Profit & Loss': 'लाभ और हानि',
  'Reference': 'रेफरेंस',
  'References': 'रेफरेंस',
  'Item': 'आइटम',
  'Restaurant Guests': 'रेस्टोरेंट गेस्ट',
  'Customer Dues': 'कस्टमर बकाया',
  'Communication': 'कम्युनिकेशन',
  'Support Tickets': 'सपोर्ट टिकट',
  'Support Admin': 'सपोर्ट एडमिन',
  'Settings': 'सेटिंग',
  'Hotels': 'होटल',
  'Restaurant Masters': 'रेस्टोरेंट मास्टर',
  'Categories': 'कैटेगरी',
  'Items': 'आइटम',
  'Areas': 'एरिया',
  'Area Pricing': 'एरिया प्राइसिंग',
  'Variants': 'वेरिएंट',
  'Stores': 'स्टोर',
  'Store Mapping': 'स्टोर मैपिंग',
  'Permissions': 'परमिशन',

  // ---- dashboard ----
  'Hotel Status': 'होटल स्थिति',
  "Today's Movement": 'आज की आवाजाही',
  'Tomorrow': 'कल',
  'Business Performance': 'बिज़नेस परफॉर्मेंस',
  'Payments Today': 'आज के पेमेंट',
  'Needs Your Attention': 'आपके ध्यान की ज़रूरत',
  "Today's Arrivals": 'आज के आगमन',
  "Today's Departures": 'आज के प्रस्थान',
  'Quick Actions': 'क्विक एक्शन',
  'Room Status Overview': 'रूम स्थिति सारांश',
  'Recent Activity': 'हाल की गतिविधि',
  'Occupied': 'भरे हुए',
  'Available': 'उपलब्ध',
  'Cleaning': 'सफाई',
  'Out of Order': 'खराब',
  'Arrivals': 'आगमन',
  'Departures': 'प्रस्थान',
  'Guests In-House': 'ठहरे हुए गेस्ट',
  'Stayovers': 'रुके हुए',
  'Available Rooms': 'उपलब्ध रूम',
  'Room Sales': 'रूम सेल',
  'Restaurant Sales': 'रेस्टोरेंट सेल',
  'Other Sales': 'अन्य सेल',
  'Total Sales': 'कुल सेल',
  'This Month': 'इस महीने',
  'This Year': 'इस साल',
  'Total Received': 'कुल प्राप्त',
  'Received': 'प्राप्त',
  'Outstanding': 'बकाया',
  'Late Checkouts': 'देर से चेकआउट',
  'Rooms Waiting for Cleaning': 'सफाई के इंतज़ार में रूम',
  'Payments Due': 'बकाया पेमेंट',
  'Walk-in': 'वॉक-इन',
  'Room Board': 'रूम बोर्ड',
  'Create Bill': 'बिल बनाएँ',
  'View All': 'सभी देखें',
  'View Reports': 'रिपोर्ट देखें',
  'View Payments': 'पेमेंट देखें',
  'View Calendar': 'कैलेंडर देखें',
  'View Room Status': 'रूम स्थिति देखें',
  'View Room Board': 'रूम बोर्ड देखें',
  'All Hotels': 'सभी होटल',
  'Business Date': 'बिज़नेस तारीख',
  'Business Date:': 'बिज़नेस तारीख:',
  'Occupancy tonight': 'आज रात की ऑक्यूपेंसी',
  "Today's sales": 'आज की सेल',
  'Collected today': 'आज वसूल',
  'Outstanding (in-house)': 'बकाया (ठहरे हुए)',

  // ---- common actions / labels ----
  'Save': 'सेव करें',
  'Cancel': 'रद्द करें',
  'Delete': 'हटाएँ',
  'Edit': 'संपादित करें',
  'Add': 'जोड़ें',
  'Search': 'खोजें',
  'Print': 'प्रिंट',
  'Close': 'बंद करें',
  'Back': 'पीछे',
  'Next': 'आगे',
  'Confirm': 'पुष्टि करें',
  'Submit': 'सबमिट',
  'Update': 'अपडेट',
  'Refresh': 'रीफ्रेश',
  'Export': 'एक्सपोर्ट',
  'Excel': 'एक्सेल',
  'Load': 'लोड',
  'Filter': 'फ़िल्टर',
  'Clear': 'साफ़ करें',
  'Apply': 'लागू करें',
  'Yes': 'हाँ',
  'No': 'नहीं',
  'OK': 'ठीक है',
  'Manage': 'मैनेज',
  'Check In': 'चेक इन',
  'Check-In': 'चेक-इन',
  'Check Out': 'चेक आउट',
  'Check-Out': 'चेक-आउट',
  'Checked In': 'चेक इन हो गया',
  'Checked Out': 'चेक आउट हो गया',
  'Expected': 'अपेक्षित',
  'Due Out': 'आज जाना है',
  'In House': 'ठहरे हुए',
  'In-House': 'ठहरे हुए',
  'Reserved': 'रिज़र्व',
  'Cancelled': 'रद्द',
  'Pending': 'लंबित',
  'Paid': 'भुगतान हुआ',
  'Due': 'बकाया',
  'Total': 'कुल',
  'Date': 'तारीख',
  'Time': 'समय',
  'Status': 'स्थिति',
  'Amount': 'राशि',
  'Quantity': 'मात्रा',
  'Name': 'नाम',
  'Mobile': 'मोबाइल',
  'Email': 'ईमेल',
  'Address': 'पता',
  'City': 'शहर',
  'Table': 'टेबल',
  'Room': 'रूम',
  'Customer': 'कस्टमर',
  'Price': 'कीमत',
  'Discount': 'छूट',
  'Nights': 'रातें',
  'Adults': 'वयस्क',
  'Children': 'बच्चे',
  'Remark': 'टिप्पणी',
  'Source': 'स्रोत',
  'Action': 'एक्शन',
  'Actions': 'एक्शन',
  'Loading...': 'लोड हो रहा है...',
  'No data found': 'कोई डेटा नहीं मिला',
  'Saved successfully': 'सफलतापूर्वक सेव हुआ',
  'Something went wrong': 'कुछ गलत हो गया',
  'Cash': 'नकद',
  'Card': 'कार्ड',
  'Online': 'ऑनलाइन',
  'Wallet': 'वॉलेट',
  'Bank Transfer': 'बैंक ट्रांसफर',
  'Other': 'अन्य',
};

const mr = {
  'Welcome back': 'पुन्हा स्वागत आहे',
  'Sign in to your Hotel Desk account': 'तुमच्या Hotel Desk खात्यात साइन इन करा',
  'Company Code': 'कंपनी कोड',
  'Enter company code': 'कंपनी कोड टाका',
  'Provided by your administrator': 'तुमच्या प्रशासकाने दिलेला',
  'Username': 'युजरनेम',
  'Enter username': 'युजरनेम टाका',
  'Password': 'पासवर्ड',
  'Enter password': 'पासवर्ड टाका',
  'Remember me': 'मला लक्षात ठेवा',
  'Forgot password?': 'पासवर्ड विसरलात?',
  'Sign In': 'साइन इन',
  'Need help?': 'मदत हवी आहे?',
  'Contact your administrator': 'तुमच्या प्रशासकाशी संपर्क साधा',
  "Don't have an account?": 'खाते नाही?',
  'Sign Up': 'साइन अप',
  'Language': 'भाषा',
  'Dashboard': 'डॅशबोर्ड',
  'Hotel Dashboard': 'हॉटेल डॅशबोर्ड',
  'Restaurant Dashboard': 'रेस्टॉरंट डॅशबोर्ड',
  'Reception': 'रिसेप्शन',
  'Bookings': 'बुकिंग',
  'Guests': 'पाहुणे',
  'Accommodation': 'निवास',
  'Restaurant': 'रेस्टॉरंट',
  'Orders': 'ऑर्डर',
  'Kitchen': 'किचन',
  'Services': 'सेवा',
  'Store': 'स्टोअर',
  'Stock': 'स्टॉक',
  'Purchase': 'खरेदी',
  'Accounts': 'खाती',
  'Payments': 'पेमेंट',
  'Staff': 'कर्मचारी',
  'Employees': 'कर्मचारी',
  'Attendance': 'हजेरी',
  'Payroll': 'पगारपट',
  'Reports': 'अहवाल',
  'Night Audit': 'नाईट ऑडिट',
  'Setup': 'सेटअप',
  'Rooms': 'खोल्या',
  'Room Types': 'खोल्यांचे प्रकार',
  'Packages': 'पॅकेज',
  'Users': 'युजर',
  'Help': 'मदत',
  'Logout': 'लॉगआउट',
  'Are you sure you want to logout?': 'तुम्हाला खरंच लॉगआउट करायचं आहे का?',
  'Overview': 'आढावा',
  'New Booking': 'नवीन बुकिंग',
  'Fast Booking': 'फास्ट बुकिंग',
  'Today': 'आज',
  'Room Calendar': 'रूम कॅलेंडर',
  'New Order': 'नवीन ऑर्डर',
  'Settings': 'सेटिंग्ज',
  'Hotel Status': 'हॉटेल स्थिती',
  "Today's Movement": 'आजची हालचाल',
  'Tomorrow': 'उद्या',
  'Business Performance': 'व्यवसाय कामगिरी',
  'Payments Today': 'आजचे पेमेंट',
  'Needs Your Attention': 'तुमचे लक्ष हवे',
  "Today's Arrivals": 'आजचे आगमन',
  "Today's Departures": 'आजचे प्रस्थान',
  'Quick Actions': 'जलद कृती',
  'Occupied': 'व्यापलेल्या',
  'Available': 'उपलब्ध',
  'Cleaning': 'साफसफाई',
  'Out of Order': 'बंद',
  'Arrivals': 'आगमन',
  'Departures': 'प्रस्थान',
  'Room Sales': 'रूम विक्री',
  'Restaurant Sales': 'रेस्टॉरंट विक्री',
  'Other Sales': 'इतर विक्री',
  'Total Sales': 'एकूण विक्री',
  'This Month': 'या महिन्यात',
  'This Year': 'या वर्षी',
  'Received': 'मिळाले',
  'Outstanding': 'बाकी',
  'View All': 'सर्व पहा',
  'All Hotels': 'सर्व हॉटेल',
  'Save': 'सेव्ह करा',
  'Cancel': 'रद्द करा',
  'Delete': 'हटवा',
  'Edit': 'संपादित करा',
  'Add': 'जोडा',
  'Search': 'शोधा',
  'Print': 'प्रिंट',
  'Close': 'बंद करा',
  'Back': 'मागे',
  'Next': 'पुढे',
  'Confirm': 'पुष्टी करा',
  'Submit': 'सबमिट',
  'Update': 'अपडेट',
  'Check In': 'चेक इन',
  'Check Out': 'चेक आउट',
  'Total': 'एकूण',
  'Date': 'तारीख',
  'Time': 'वेळ',
  'Status': 'स्थिती',
  'Amount': 'रक्कम',
  'Quantity': 'प्रमाण',
  'Name': 'नाव',
  'Mobile': 'मोबाइल',
  'Table': 'टेबल',
  'Room': 'खोली',
  'Customer': 'ग्राहक',
  'Item': 'आयटम',
  'Price': 'किंमत',
  'Paid': 'भरले',
  'Due': 'बाकी',
  'Loading...': 'लोड होत आहे...',
  'No data found': 'डेटा सापडला नाही',
  'Cash': 'रोख',
  'Card': 'कार्ड',
  'Online': 'ऑनलाइन',
  'Other': 'इतर',
};

const gu = {
  'Welcome back': 'ફરી સ્વાગત છે',
  'Sign in to your Hotel Desk account': 'તમારા Hotel Desk ખાતામાં સાઇન ઇન કરો',
  'Company Code': 'કંપની કોડ',
  'Enter company code': 'કંપની કોડ દાખલ કરો',
  'Provided by your administrator': 'તમારા એડમિનિસ્ટ્રેટર દ્વારા અપાયેલ',
  'Username': 'યુઝરનેમ',
  'Enter username': 'યુઝરનેમ દાખલ કરો',
  'Password': 'પાસવર્ડ',
  'Enter password': 'પાસવર્ડ દાખલ કરો',
  'Remember me': 'મને યાદ રાખો',
  'Forgot password?': 'પાસવર્ડ ભૂલી ગયા?',
  'Sign In': 'સાઇન ઇન',
  'Need help?': 'મદદ જોઈએ છે?',
  'Contact your administrator': 'તમારા એડમિનિસ્ટ્રેટરનો સંપર્ક કરો',
  "Don't have an account?": 'ખાતું નથી?',
  'Sign Up': 'સાઇન અપ',
  'Language': 'ભાષા',
  'Dashboard': 'ડેશબોર્ડ',
  'Hotel Dashboard': 'હોટેલ ડેશબોર્ડ',
  'Restaurant Dashboard': 'રેસ્ટોરન્ટ ડેશબોર્ડ',
  'Reception': 'રિસેપ્શન',
  'Bookings': 'બુકિંગ',
  'Guests': 'મહેમાનો',
  'Accommodation': 'રહેઠાણ',
  'Restaurant': 'રેસ્ટોરન્ટ',
  'Orders': 'ઓર્ડર',
  'Kitchen': 'રસોડું',
  'Services': 'સેવાઓ',
  'Store': 'સ્ટોર',
  'Stock': 'સ્ટોક',
  'Purchase': 'ખરીદી',
  'Accounts': 'ખાતાં',
  'Payments': 'ચુકવણી',
  'Staff': 'સ્ટાફ',
  'Employees': 'કર્મચારીઓ',
  'Attendance': 'હાજરી',
  'Payroll': 'પગારપત્રક',
  'Reports': 'રિપોર્ટ',
  'Night Audit': 'નાઇટ ઓડિટ',
  'Setup': 'સેટઅપ',
  'Rooms': 'રૂમ',
  'Room Types': 'રૂમ પ્રકાર',
  'Packages': 'પેકેજ',
  'Users': 'યુઝર',
  'Help': 'મદદ',
  'Logout': 'લોગઆઉટ',
  'Are you sure you want to logout?': 'શું તમે ખરેખર લોગઆઉટ કરવા માંગો છો?',
  'Overview': 'ઝાંખી',
  'New Booking': 'નવી બુકિંગ',
  'Fast Booking': 'ફાસ્ટ બુકિંગ',
  'Today': 'આજે',
  'Room Calendar': 'રૂમ કેલેન્ડર',
  'New Order': 'નવો ઓર્ડર',
  'Settings': 'સેટિંગ્સ',
  'Hotel Status': 'હોટેલ સ્થિતિ',
  "Today's Movement": 'આજની અવરજવર',
  'Tomorrow': 'આવતીકાલે',
  'Business Performance': 'વ્યવસાય પ્રદર્શન',
  'Payments Today': 'આજની ચુકવણી',
  'Needs Your Attention': 'તમારું ધ્યાન જોઈએ',
  "Today's Arrivals": 'આજના આગમન',
  "Today's Departures": 'આજના પ્રસ્થાન',
  'Quick Actions': 'ઝડપી ક્રિયાઓ',
  'Occupied': 'ભરેલા',
  'Available': 'ઉપલબ્ધ',
  'Cleaning': 'સફાઈ',
  'Out of Order': 'બંધ',
  'Arrivals': 'આગમન',
  'Departures': 'પ્રસ્થાન',
  'Room Sales': 'રૂમ વેચાણ',
  'Restaurant Sales': 'રેસ્ટોરન્ટ વેચાણ',
  'Other Sales': 'અન્ય વેચાણ',
  'Total Sales': 'કુલ વેચાણ',
  'This Month': 'આ મહિને',
  'This Year': 'આ વર્ષે',
  'Received': 'મળેલ',
  'Outstanding': 'બાકી',
  'View All': 'બધું જુઓ',
  'All Hotels': 'બધી હોટેલ',
  'Save': 'સેવ કરો',
  'Cancel': 'રદ કરો',
  'Delete': 'કાઢી નાખો',
  'Edit': 'સંપાદિત કરો',
  'Add': 'ઉમેરો',
  'Search': 'શોધો',
  'Print': 'પ્રિન્ટ',
  'Close': 'બંધ કરો',
  'Back': 'પાછળ',
  'Next': 'આગળ',
  'Confirm': 'પુષ્ટિ કરો',
  'Submit': 'સબમિટ',
  'Update': 'અપડેટ',
  'Check In': 'ચેક ઇન',
  'Check Out': 'ચેક આઉટ',
  'Total': 'કુલ',
  'Date': 'તારીખ',
  'Time': 'સમય',
  'Status': 'સ્થિતિ',
  'Amount': 'રકમ',
  'Quantity': 'જથ્થો',
  'Name': 'નામ',
  'Mobile': 'મોબાઇલ',
  'Table': 'ટેબલ',
  'Room': 'રૂમ',
  'Customer': 'ગ્રાહક',
  'Item': 'આઇટમ',
  'Price': 'કિંમત',
  'Paid': 'ચૂકવેલ',
  'Due': 'બાકી',
  'Loading...': 'લોડ થઈ રહ્યું છે...',
  'No data found': 'કોઈ ડેટા મળ્યો નથી',
  'Cash': 'રોકડ',
  'Card': 'કાર્ડ',
  'Online': 'ઓનલાઇન',
  'Other': 'અન્ય',
};

const bn = {
  'Welcome back': 'আবার স্বাগতম',
  'Sign in to your Hotel Desk account': 'আপনার Hotel Desk অ্যাকাউন্টে সাইন ইন করুন',
  'Company Code': 'কোম্পানি কোড',
  'Enter company code': 'কোম্পানি কোড লিখুন',
  'Provided by your administrator': 'আপনার অ্যাডমিনিস্ট্রেটর দিয়েছেন',
  'Username': 'ইউজারনেম',
  'Enter username': 'ইউজারনেম লিখুন',
  'Password': 'পাসওয়ার্ড',
  'Enter password': 'পাসওয়ার্ড লিখুন',
  'Remember me': 'আমাকে মনে রাখুন',
  'Forgot password?': 'পাসওয়ার্ড ভুলে গেছেন?',
  'Sign In': 'সাইন ইন',
  'Need help?': 'সাহায্য দরকার?',
  'Contact your administrator': 'আপনার অ্যাডমিনিস্ট্রেটরের সাথে যোগাযোগ করুন',
  "Don't have an account?": 'অ্যাকাউন্ট নেই?',
  'Sign Up': 'সাইন আপ',
  'Language': 'ভাষা',
  'Dashboard': 'ড্যাশবোর্ড',
  'Hotel Dashboard': 'হোটেল ড্যাশবোর্ড',
  'Restaurant Dashboard': 'রেস্টুরেন্ট ড্যাশবোর্ড',
  'Reception': 'রিসেপশন',
  'Bookings': 'বুকিং',
  'Guests': 'অতিথি',
  'Accommodation': 'আবাসন',
  'Restaurant': 'রেস্টুরেন্ট',
  'Orders': 'অর্ডার',
  'Kitchen': 'রান্নাঘর',
  'Services': 'সেবা',
  'Store': 'স্টোর',
  'Stock': 'স্টক',
  'Purchase': 'ক্রয়',
  'Accounts': 'হিসাব',
  'Payments': 'পেমেন্ট',
  'Staff': 'কর্মী',
  'Employees': 'কর্মচারী',
  'Attendance': 'উপস্থিতি',
  'Payroll': 'বেতন',
  'Reports': 'রিপোর্ট',
  'Night Audit': 'নাইট অডিট',
  'Setup': 'সেটআপ',
  'Rooms': 'রুম',
  'Room Types': 'রুমের ধরন',
  'Packages': 'প্যাকেজ',
  'Users': 'ইউজার',
  'Help': 'সাহায্য',
  'Logout': 'লগআউট',
  'Are you sure you want to logout?': 'আপনি কি সত্যিই লগআউট করতে চান?',
  'Overview': 'সারসংক্ষেপ',
  'New Booking': 'নতুন বুকিং',
  'Fast Booking': 'ফাস্ট বুকিং',
  'Today': 'আজ',
  'Room Calendar': 'রুম ক্যালেন্ডার',
  'New Order': 'নতুন অর্ডার',
  'Settings': 'সেটিংস',
  'Hotel Status': 'হোটেলের অবস্থা',
  "Today's Movement": 'আজকের আসা-যাওয়া',
  'Tomorrow': 'আগামীকাল',
  'Business Performance': 'ব্যবসার পারফরম্যান্স',
  'Payments Today': 'আজকের পেমেন্ট',
  'Needs Your Attention': 'আপনার নজর দরকার',
  "Today's Arrivals": 'আজকের আগমন',
  "Today's Departures": 'আজকের প্রস্থান',
  'Quick Actions': 'দ্রুত কাজ',
  'Occupied': 'ভরা',
  'Available': 'খালি',
  'Cleaning': 'পরিষ্কার',
  'Out of Order': 'বন্ধ',
  'Arrivals': 'আগমন',
  'Departures': 'প্রস্থান',
  'Room Sales': 'রুম বিক্রি',
  'Restaurant Sales': 'রেস্টুরেন্ট বিক্রি',
  'Other Sales': 'অন্যান্য বিক্রি',
  'Total Sales': 'মোট বিক্রি',
  'This Month': 'এই মাসে',
  'This Year': 'এই বছরে',
  'Received': 'প্রাপ্ত',
  'Outstanding': 'বকেয়া',
  'View All': 'সব দেখুন',
  'All Hotels': 'সব হোটেল',
  'Save': 'সেভ করুন',
  'Cancel': 'বাতিল',
  'Delete': 'মুছুন',
  'Edit': 'সম্পাদনা',
  'Add': 'যোগ করুন',
  'Search': 'খুঁজুন',
  'Print': 'প্রিন্ট',
  'Close': 'বন্ধ করুন',
  'Back': 'পিছনে',
  'Next': 'পরবর্তী',
  'Confirm': 'নিশ্চিত করুন',
  'Submit': 'জমা দিন',
  'Update': 'আপডেট',
  'Check In': 'চেক ইন',
  'Check Out': 'চেক আউট',
  'Total': 'মোট',
  'Date': 'তারিখ',
  'Time': 'সময়',
  'Status': 'অবস্থা',
  'Amount': 'পরিমাণ',
  'Quantity': 'সংখ্যা',
  'Name': 'নাম',
  'Mobile': 'মোবাইল',
  'Table': 'টেবিল',
  'Room': 'রুম',
  'Customer': 'গ্রাহক',
  'Item': 'আইটেম',
  'Price': 'দাম',
  'Paid': 'পরিশোধিত',
  'Due': 'বকেয়া',
  'Loading...': 'লোড হচ্ছে...',
  'No data found': 'কোনো ডেটা পাওয়া যায়নি',
  'Cash': 'নগদ',
  'Card': 'কার্ড',
  'Online': 'অনলাইন',
  'Other': 'অন্যান্য',
};

const ta = {
  'Welcome back': 'மீண்டும் வரவேற்கிறோம்',
  'Sign in to your Hotel Desk account': 'உங்கள் Hotel Desk கணக்கில் உள்நுழையவும்',
  'Company Code': 'நிறுவனக் குறியீடு',
  'Enter company code': 'நிறுவனக் குறியீட்டை உள்ளிடவும்',
  'Provided by your administrator': 'உங்கள் நிர்வாகி வழங்கியது',
  'Username': 'பயனர் பெயர்',
  'Enter username': 'பயனர் பெயரை உள்ளிடவும்',
  'Password': 'கடவுச்சொல்',
  'Enter password': 'கடவுச்சொல்லை உள்ளிடவும்',
  'Remember me': 'என்னை நினைவில் வை',
  'Forgot password?': 'கடவுச்சொல் மறந்துவிட்டதா?',
  'Sign In': 'உள்நுழை',
  'Need help?': 'உதவி வேண்டுமா?',
  'Contact your administrator': 'உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளவும்',
  "Don't have an account?": 'கணக்கு இல்லையா?',
  'Sign Up': 'பதிவு செய்',
  'Language': 'மொழி',
  'Dashboard': 'டாஷ்போர்டு',
  'Hotel Dashboard': 'ஹோட்டல் டாஷ்போர்டு',
  'Restaurant Dashboard': 'உணவக டாஷ்போர்டு',
  'Reception': 'வரவேற்பு',
  'Bookings': 'முன்பதிவுகள்',
  'Guests': 'விருந்தினர்கள்',
  'Accommodation': 'தங்குமிடம்',
  'Restaurant': 'உணவகம்',
  'Orders': 'ஆர்டர்கள்',
  'Kitchen': 'சமையலறை',
  'Services': 'சேவைகள்',
  'Store': 'ஸ்டோர்',
  'Stock': 'இருப்பு',
  'Purchase': 'கொள்முதல்',
  'Accounts': 'கணக்குகள்',
  'Payments': 'பணம் செலுத்துதல்',
  'Staff': 'பணியாளர்கள்',
  'Employees': 'ஊழியர்கள்',
  'Attendance': 'வருகை',
  'Payroll': 'சம்பளப் பட்டியல்',
  'Reports': 'அறிக்கைகள்',
  'Night Audit': 'இரவு தணிக்கை',
  'Setup': 'அமைப்பு',
  'Rooms': 'அறைகள்',
  'Room Types': 'அறை வகைகள்',
  'Packages': 'பேக்கேஜ்கள்',
  'Users': 'பயனர்கள்',
  'Help': 'உதவி',
  'Logout': 'வெளியேறு',
  'Are you sure you want to logout?': 'நிச்சயமாக வெளியேற வேண்டுமா?',
  'Overview': 'மேலோட்டம்',
  'New Booking': 'புதிய முன்பதிவு',
  'Fast Booking': 'விரைவு முன்பதிவு',
  'Today': 'இன்று',
  'Room Calendar': 'அறை காலண்டர்',
  'New Order': 'புதிய ஆர்டர்',
  'Settings': 'அமைப்புகள்',
  'Hotel Status': 'ஹோட்டல் நிலை',
  "Today's Movement": 'இன்றைய நடமாட்டம்',
  'Tomorrow': 'நாளை',
  'Business Performance': 'வணிக செயல்திறன்',
  'Payments Today': 'இன்றைய பணம்',
  'Needs Your Attention': 'உங்கள் கவனம் தேவை',
  "Today's Arrivals": 'இன்றைய வருகைகள்',
  "Today's Departures": 'இன்றைய புறப்பாடுகள்',
  'Quick Actions': 'விரைவு செயல்கள்',
  'Occupied': 'நிரம்பியவை',
  'Available': 'கிடைக்கும்',
  'Cleaning': 'சுத்தம்',
  'Out of Order': 'பழுது',
  'Arrivals': 'வருகைகள்',
  'Departures': 'புறப்பாடுகள்',
  'Room Sales': 'அறை விற்பனை',
  'Restaurant Sales': 'உணவக விற்பனை',
  'Other Sales': 'பிற விற்பனை',
  'Total Sales': 'மொத்த விற்பனை',
  'This Month': 'இந்த மாதம்',
  'This Year': 'இந்த ஆண்டு',
  'Received': 'பெறப்பட்டது',
  'Outstanding': 'நிலுவை',
  'View All': 'அனைத்தையும் காண்க',
  'All Hotels': 'அனைத்து ஹோட்டல்கள்',
  'Save': 'சேமி',
  'Cancel': 'ரத்து',
  'Delete': 'நீக்கு',
  'Edit': 'திருத்து',
  'Add': 'சேர்',
  'Search': 'தேடு',
  'Print': 'அச்சிடு',
  'Close': 'மூடு',
  'Back': 'பின்',
  'Next': 'அடுத்து',
  'Confirm': 'உறுதிப்படுத்து',
  'Submit': 'சமர்ப்பி',
  'Update': 'புதுப்பி',
  'Check In': 'செக் இன்',
  'Check Out': 'செக் அவுட்',
  'Total': 'மொத்தம்',
  'Date': 'தேதி',
  'Time': 'நேரம்',
  'Status': 'நிலை',
  'Amount': 'தொகை',
  'Quantity': 'அளவு',
  'Name': 'பெயர்',
  'Mobile': 'மொபைல்',
  'Table': 'மேசை',
  'Room': 'அறை',
  'Customer': 'வாடிக்கையாளர்',
  'Item': 'பொருள்',
  'Price': 'விலை',
  'Paid': 'செலுத்தியது',
  'Due': 'நிலுவை',
  'Loading...': 'ஏற்றுகிறது...',
  'No data found': 'தரவு இல்லை',
  'Cash': 'ரொக்கம்',
  'Card': 'கார்டு',
  'Online': 'ஆன்லைன்',
  'Other': 'பிற',
};

const te = {
  'Welcome back': 'తిరిగి స్వాగతం',
  'Sign in to your Hotel Desk account': 'మీ Hotel Desk ఖాతాలో సైన్ ఇన్ అవ్వండి',
  'Company Code': 'కంపెనీ కోడ్',
  'Enter company code': 'కంపెనీ కోడ్ నమోదు చేయండి',
  'Provided by your administrator': 'మీ అడ్మినిస్ట్రేటర్ ఇచ్చినది',
  'Username': 'యూజర్‌నేమ్',
  'Enter username': 'యూజర్‌నేమ్ నమోదు చేయండి',
  'Password': 'పాస్‌వర్డ్',
  'Enter password': 'పాస్‌వర్డ్ నమోదు చేయండి',
  'Remember me': 'నన్ను గుర్తుంచుకో',
  'Forgot password?': 'పాస్‌వర్డ్ మర్చిపోయారా?',
  'Sign In': 'సైన్ ఇన్',
  'Need help?': 'సహాయం కావాలా?',
  'Contact your administrator': 'మీ అడ్మినిస్ట్రేటర్‌ను సంప్రదించండి',
  "Don't have an account?": 'ఖాతా లేదా?',
  'Sign Up': 'సైన్ అప్',
  'Language': 'భాష',
  'Dashboard': 'డాష్‌బోర్డ్',
  'Hotel Dashboard': 'హోటల్ డాష్‌బోర్డ్',
  'Restaurant Dashboard': 'రెస్టారెంట్ డాష్‌బోర్డ్',
  'Reception': 'రిసెప్షన్',
  'Bookings': 'బుకింగ్‌లు',
  'Guests': 'అతిథులు',
  'Accommodation': 'వసతి',
  'Restaurant': 'రెస్టారెంట్',
  'Orders': 'ఆర్డర్లు',
  'Kitchen': 'వంటగది',
  'Services': 'సేవలు',
  'Store': 'స్టోర్',
  'Stock': 'స్టాక్',
  'Purchase': 'కొనుగోలు',
  'Accounts': 'ఖాతాలు',
  'Payments': 'చెల్లింపులు',
  'Staff': 'సిబ్బంది',
  'Employees': 'ఉద్యోగులు',
  'Attendance': 'హాజరు',
  'Payroll': 'జీతాల పట్టిక',
  'Reports': 'నివేదికలు',
  'Night Audit': 'నైట్ ఆడిట్',
  'Setup': 'సెటప్',
  'Rooms': 'గదులు',
  'Room Types': 'గది రకాలు',
  'Packages': 'ప్యాకేజీలు',
  'Users': 'యూజర్లు',
  'Help': 'సహాయం',
  'Logout': 'లాగ్ అవుట్',
  'Are you sure you want to logout?': 'మీరు నిజంగా లాగ్ అవుట్ అవ్వాలనుకుంటున్నారా?',
  'Overview': 'అవలోకనం',
  'New Booking': 'కొత్త బుకింగ్',
  'Fast Booking': 'ఫాస్ట్ బుకింగ్',
  'Today': 'ఈరోజు',
  'Room Calendar': 'గది క్యాలెండర్',
  'New Order': 'కొత్త ఆర్డర్',
  'Settings': 'సెట్టింగ్‌లు',
  'Hotel Status': 'హోటల్ స్థితి',
  "Today's Movement": 'ఈరోజు రాకపోకలు',
  'Tomorrow': 'రేపు',
  'Business Performance': 'వ్యాపార పనితీరు',
  'Payments Today': 'ఈరోజు చెల్లింపులు',
  'Needs Your Attention': 'మీ దృష్టి అవసరం',
  "Today's Arrivals": 'ఈరోజు రాకలు',
  "Today's Departures": 'ఈరోజు నిష్క్రమణలు',
  'Quick Actions': 'త్వరిత చర్యలు',
  'Occupied': 'నిండినవి',
  'Available': 'అందుబాటులో',
  'Cleaning': 'శుభ్రత',
  'Out of Order': 'పనిచేయనివి',
  'Arrivals': 'రాకలు',
  'Departures': 'నిష్క్రమణలు',
  'Room Sales': 'గది అమ్మకాలు',
  'Restaurant Sales': 'రెస్టారెంట్ అమ్మకాలు',
  'Other Sales': 'ఇతర అమ్మకాలు',
  'Total Sales': 'మొత్తం అమ్మకాలు',
  'This Month': 'ఈ నెల',
  'This Year': 'ఈ సంవత్సరం',
  'Received': 'అందినది',
  'Outstanding': 'బకాయి',
  'View All': 'అన్నీ చూడండి',
  'All Hotels': 'అన్ని హోటళ్లు',
  'Save': 'సేవ్ చేయి',
  'Cancel': 'రద్దు',
  'Delete': 'తొలగించు',
  'Edit': 'సవరించు',
  'Add': 'జోడించు',
  'Search': 'వెతుకు',
  'Print': 'ప్రింట్',
  'Close': 'మూసివేయి',
  'Back': 'వెనుకకు',
  'Next': 'తదుపరి',
  'Confirm': 'నిర్ధారించు',
  'Submit': 'సమర్పించు',
  'Update': 'అప్‌డేట్',
  'Check In': 'చెక్ ఇన్',
  'Check Out': 'చెక్ అవుట్',
  'Total': 'మొత్తం',
  'Date': 'తేదీ',
  'Time': 'సమయం',
  'Status': 'స్థితి',
  'Amount': 'మొత్తం',
  'Quantity': 'పరిమాణం',
  'Name': 'పేరు',
  'Mobile': 'మొబైల్',
  'Table': 'టేబుల్',
  'Room': 'గది',
  'Customer': 'కస్టమర్',
  'Item': 'వస్తువు',
  'Price': 'ధర',
  'Paid': 'చెల్లించినది',
  'Due': 'బకాయి',
  'Loading...': 'లోడ్ అవుతోంది...',
  'No data found': 'డేటా లేదు',
  'Cash': 'నగదు',
  'Card': 'కార్డ్',
  'Online': 'ఆన్‌లైన్',
  'Other': 'ఇతర',
};

export const PHRASES = { hi, mr, gu, bn, ta, te };
